import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { BannerComponent } from './banner.component';

@NgModule({
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule],
  exports: [BannerComponent],
  declarations: [BannerComponent]
})
export class BannerModule {}
